import React from 'react';
import { ReactComponent as InfoSVG } from '../../assets/images/icons/info-beta.svg';

export default function InfoIconBeta(props) {
  const { theme } = props;

  return (
    <InfoSVG {...props} fill={theme.simulation.iconColor} className={'icon'} />
  );
}

export function InfoIconEvolutive(props) {

  return (
    <InfoSVG className={`icon ${props.className}`} />
  );
}
